var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopAppIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9844 16.8866C26.9844 19.8287 24.7099 22.2078 21.8297 22.2078C18.9496 22.2078 16.7052 19.8881 16.7052 16.8866C16.7052 15.4749 17.2231 14.2274 18.0452 13.291L14.5622 16.8866L12.7344 14.9997L16.6641 10.9854C17.1957 10.4366 17.4698 9.72088 17.4698 8.93443V3.8961H20.0457V8.93443C20.0457 10.479 19.5141 11.7888 18.4755 12.8582L18.3604 12.977C19.2675 12.1142 20.5061 11.5936 21.8297 11.5936C24.7537 11.5936 26.9844 13.9869 26.9844 16.8837M24.6523 16.8837C24.6523 15.308 23.3863 14.0293 21.8297 14.0293C20.2732 14.0293 19.0373 15.3674 19.0373 16.8837C19.0373 18.4 20.2759 19.7664 21.8297 19.7664C23.3835 19.7664 24.6523 18.4142 24.6523 16.8837Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8594 1.55844H1.85938V24.9351H37.8594V1.55844ZM0.359375 0V26.4935H39.3594V0H0.359375Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7344 28.4416H26.9844V30H12.7344V28.4416Z",
    fill: "#BDBDBD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopAppIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop-app-icon.e80e9c718f8f5425b7dfac3758bbe430.svg";